import ApiService from "../common/api.service";
import { SET_ARTICLE_ERROR } from "../store/types";
import handleReject from "../common/handleReject";

export default {
  methods: {
    setArticlePoster(formData, busy = true){
      busy && this.showBusy();
      return new Promise((resolve, reject) => {
        ApiService.setHeader();
        ApiService.put(`/manager/articles/poster-setting`, formData)
        .then((response)=>{
          this.$store.commit(SET_ARTICLE_ERROR, null);
          resolve(response);
          busy && this.hideBusy();
        })
        .catch(response=>{
          handleReject(this.$store, response, SET_ARTICLE_ERROR);
          reject(response);
          busy && this.hideBusy();
        })
      })
    },
    getArticlePoster(busy = true){
      busy && this.showBusy();
      return new Promise((resolve, reject) => {
        ApiService.setHeader();
        ApiService.get(`/manager/articles/poster-setting`)
        .then((response)=>{
          this.$store.commit(SET_ARTICLE_ERROR, null);
          resolve(response);
          busy && this.hideBusy();
        })
        .catch(response=>{
          handleReject(this.$store, response, SET_ARTICLE_ERROR);
          reject(response);
          busy && this.hideBusy();
        })
      })
    },
  }
}
